import styled from '@emotion/styled';
import { Card } from 'src/components-dummy/Card';

export const CollectionSnippetStyled = styled(Card)`
  margin-bottom: 90px;
  padding: 32px;
  max-width: 100%;
`;
